import React from 'react';
import classNames from 'classnames';
import type { MaintenanceRequestPriority } from '../../core/Types';
import priorityStyles from '../../stylesheets/maintenance/priorityPill.module.scss';

interface PriorityPillProps {
  priority: MaintenanceRequestPriority;
}

const PRIORITY_LABELS: Record<MaintenanceRequestPriority, string> = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
};

const PriorityPill = ({ priority }: PriorityPillProps) => {
  const priorityClass = {
    high: priorityStyles.priorityHigh,
    medium: priorityStyles.priorityMedium,
    low: priorityStyles.priorityLow,
  }[priority];

  return (
    <span className={classNames(priorityStyles.priorityPill, priorityClass)}>
      {PRIORITY_LABELS[priority]} Priority
    </span>
  );
};

export default PriorityPill;
